import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { PawPrint } from '@phosphor-icons/react';
interface PawSpot {
  x: string;
  y: string;
  size: number;
  rotation: number;
  phase: number;
  color: string;
  maxOpacity: number;
}
function seededRandom(seed: number) {
  let s = seed;
  return () => {
    s = (s * 16807 + 0) % 2147483647;
    return s / 2147483647;
  };
}
function generateSpots(count: number): PawSpot[] {
  const rng = seededRandom(42);
  const colors = ['#FB8500', '#FFB703', '#FDE68A', '#FF9500' // warm orange
  ];
  return Array.from({
    length: count
  }, (_, i) => ({
    x: `${rng() * 100}%`,
    y: `${rng() * 100}%`,
    size: 20 + rng() * 28,
    rotation: (rng() - 0.5) * 180,
    phase: rng(),
    color: colors[i % colors.length],
    maxOpacity: 0.25 + rng() * 0.25
  }));
}
export function PawBackground() {
  const spots = useMemo(() => generateSpots(22), []);
  return <div className="absolute inset-0 pointer-events-none z-[1] overflow-hidden" data-id="element-143">
      {spots.map((spot, i) => <motion.div key={i} className="absolute" style={{
      left: spot.x,
      top: spot.y,
      rotate: spot.rotation
    }} animate={{
      opacity: [0, spot.maxOpacity, 0]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: spot.phase * 4
    }} data-id="element-144">
          <PawPrint size={spot.size} color={spot.color} weight="fill" data-id="element-145" />
        </motion.div>)}
    </div>;
}